/**
 * no-operation
 */
export const NOOP = (): void => {
  // empty
};
